export class Comparable {
    eq(that) {
        if (!that) {
            return false;
        }
        return this.checkAndCompare(that) === 0;
    }
    lt(that) {
        if (!that) {
            return false;
        }
        return this.checkAndCompare(that) < 0;
    }
    lte(that) {
        if (!that) {
            return false;
        }
        return this.checkAndCompare(that) <= 0;
    }
    gt(that) {
        if (!that) {
            return false;
        }
        return this.checkAndCompare(that) > 0;
    }
    gte(that) {
        if (!that) {
            return false;
        }
        return this.checkAndCompare(that) >= 0;
    }
    checkCompatible(that) {
        console.assert(this.isCompatibleWith(that));
    }
    checkAndCompare(that) {
        this.checkCompatible(that);
        return this.compare(that);
    }
}
//# sourceMappingURL=Comparable.js.map